export default __webpack_public_path__ + "static/media/pu.c4ac3d06.png";